module.exports = __webpack_public_path__ + "static/turn_on-502b19af7fd2899ae926e4d86d3bac6a.png";